import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { d: "M3 8L12 17L21 8", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
export {
  t as default
};
//# sourceMappingURL=chevron-down.js.map
